import { useQuery } from 'react-query';
import { axios, axios2 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { User } from '@/types/User';
import { TableResponse } from '@/types/TableResponse';
import { PaginationQuery } from '@/types/PaginationQuery';
import { formatURL as url } from '@/utils/format';

export type AgencyDTO = {
  status_code: number;
  status_message: string;
  total_records: number;
  page: number;
  page_size: number;
  data: Data[];
};

export type Data = {
  id: number;
  mobile_number: string;
  name: string;
  email: string;
  property_type: string;
  customer_id: number;
  property_name: string;
  property_image: string;
  property_video: string;
  property_doc: string;
  status: string;
};

export const getAgencyRequests = (
  pagination: PaginationQuery
): Promise<TableResponse<AgencyDTO>> => {
  return axios2.get(url('/agency-api/agency-accepted-request', pagination));
};

type QueryFnType = typeof getAgencyRequests;

type UseUsersOptions = {
  config?: QueryConfig<QueryFnType>;
  page_per_data?: string;
  page: string;
};

export const useAgencyRequests = ({ config, page_per_data = '10', page }: UseUsersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['get-request'],
    queryFn: () => getAgencyRequests({ page_per_data, page }),
  });
};
